export const VOUCHER_LIST_URL = 'DynamicQuery/GetVouchers';
export const VOUCHER_PRODUCT_LIST_URL = 'DynamicQuery/GetProductRefsForVouchers';
export const VOUCHER_CUSTOMERS_LIST_URL = 'DynamicQuery/FindCustomerForVoucher';
export const VOUCHER_DELETE_URL = 'DynamicQuery/DeleteVoucher';
export const VOUCHER_ADD_URL = 'DynamicQuery/AddVoucher';
export const VOUCHER_UPDATE_URL = 'DynamicQuery/UpdateVoucher';
export const VOUCHER_UPDATE_PRODUCTS_URL = 'DynamicQuery/UpdateVoucherProducts';
export const VOUCHER_UPDATE_CUSTOMERS_URL = 'DynamicQuery/UpdateVoucherCustomers';